<template>
  <div :class="[languagezh_cn ? '' : 'myCss']">
    <el-emp-footer
      :helpData="helpData"
      :qrCode="qrCode"
      :isShowCopyright="isShowCopyright"
      :serviceItemData="serviceItemData"
      :Wx="$t('page.content.officialWeChat')"
      :copyRighta="$t('page.content.Copyright1')"
      :divider="$t('page.content.divider')"
      :copyRightb="$t('page.content.statement1')"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      qrCode: require("@/basa/assets/images/code.jpg"),
      isShowCopyright: true,
      serviceItemData: [
        this.$t("page.content.resourceSharing"),
        this.$t("page.content.qualityService"),
        this.$t("page.content.legalCompliance"),
        this.$t("page.content.reduceCostsAndincrease"),
        this.$t("page.content.managementPromotion")
      ],
      helpData: [
        {
          tit: this.$t("page.content.aboutUs"),
          list: [
            { label: this.$t("page.content.introPlatform"), url: "" },
            { label: this.$t("page.content.contactUs"), url: "" },
            {
              label: this.$t("page.content.relevantPoliciesAndRegulations"),
              url: ""
            }
          ]
        },
        {
          tit: this.$t("page.content.purchaser"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "" },
            { label: this.$t("page.content.videoTutorial"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.supplier"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "" },
            { label: this.$t("page.content.videoTutorial"), url: "" },
            { label: this.$t("page.content.netInformation"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.commonProblem"),
          list: [
            { label: this.$t("page.content.purchaseCommonProblem"), url: "" },
            { label: this.$t("page.content.supplierCommonProblem"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.serviceCenter"),
          list: [
            { label: this.$t("page.content.onlineCounsel"), url: "1" },
            { label: this.$t("page.content.afterSalesService"), url: "2" },
            { label: this.$t("page.content.feedback"), url: "3" },
            { label: this.$t("page.content.fileTemplateDownload"), url: "4" }
          ]
        },
        {
          tit: this.$t("page.content.supplyChainFinanceCenter"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "5" },
            { label: this.$t("page.content.commonProblem"), url: "6" }
          ]
        }
      ]
    };
  },
  computed: {
    languagezh_cn() {
      return 'en-gb' === "zh-cn";
    }
  },
  mounted() {},
  methods: {
    search(kw) {
      console.log(kw);
    }
  }
};
</script>

<style scoped lang="scss">
.myCss {
  /deep/ .el-emp-footer .service .wrapper .service-list {
    height: 110px !important;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
  }
  /deep/
    .el-emp-footer
    .service
    .wrapper
    .service-list
    .service-item:nth-child(2) {
    margin-left: 222px;
  }
  /deep/
    .el-emp-footer
    .service
    .wrapper
    .service-list
    .service-item:nth-child(5) {
    margin-left: 356px;
  }
  /deep/
    .el-emp-footer
    .service
    .wrapper
    .service-list
    .service-item
    .service-unit {
    padding-top: 10px;
  }
  /deep/ .el-emp-footer .help .wrapper .help-list .help-nav .help-nav-con li p {
    height: 50px;
  }
  /deep/ .help-nav-tit {
    margin-bottom: 22px !important;
  }
  /deep/ .help-nav-con > li > p {
    line-height: 19px !important;
  }
  /deep/ .service-list li:nth-child(4) {
    margin-left: 0px !important;
  }
}
</style>
